import React from "react";

import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";

interface NavAccountButtonInterface {
  id: string;
  handleProfileMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
}

const NavAccountButton = ({
  id,
  handleProfileMenuOpen,
}: NavAccountButtonInterface) => {
  return (
    <Button
      aria-controls={id}
      aria-haspopup="true"
      onClick={handleProfileMenuOpen}
      variant="outlined"
      sx={{
        minWidth: 0,
        width: 40,
        height: 40,
        borderRadius: 3,
        borderColor: "#ffffff24",
        "&:hover": {
          borderColor: "#ffffff41",
        },
      }}
    >
      <FontAwesomeIcon icon={faUserCircle} color="white" size="lg" />
    </Button>
  );
};

export default NavAccountButton;
